"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
const image_file_1 = require("./image-file");
const hash_1 = require("./hash");
const account_1 = require("./account");
const subject_1 = require("./subject");
const language_1 = require("./language");
const subject_level_1 = require("./subject-level");
const user_service_category_1 = require("./user-service-category");
const user_service_stats_1 = require("./user-service-stats");
const user_service_visit_info_1 = require("./user-service-visit-info");
const user_service_can_1 = require("./user-service-can");
const user_service_is_1 = require("./user-service-is");
const http_endpoints_1 = require("../http-endpoints");
exports.UserServiceSchema = zod_1.z.object({
  id: zod_1.z.string().uuid(),
  type: zod_1.z.nativeEnum(lingo2_models_1.EUserServiceType),
  created_at: zod_1.z.string().datetime().or(zod_1.z.date()),
  moderation_status: zod_1.z.nativeEnum(lingo2_models_1.ModerationStatusEnum),
  promotion_status: zod_1.z.nativeEnum(lingo2_models_1.PromotionStatusEnum),
  advertisement_status: zod_1.z.nativeEnum(lingo2_models_1.AdvertisementStatusEnum),
  meeting_discount_rule: zod_1.z.nativeEnum(lingo2_models_1.MeetingDiscountRuleEnum).optional(),
  title: zod_1.z.string(),
  description: zod_1.z.string(),
  excerpt: zod_1.z.string().optional(),
  price_tier: zod_1.z.number(),
  slug: zod_1.z.string(),
  cover_id: zod_1.z.string().optional(),
  author_id: zod_1.z.string().uuid(),
  school_id: zod_1.z.string().uuid().optional(),
  teacher_ids: zod_1.z.array(zod_1.z.string().uuid()).optional(),
  subject_id: zod_1.z.number(),
  language_id: zod_1.z.number().optional(),
  level_id: zod_1.z.number().optional(),
  duration: zod_1.z.number().optional(),
  discount: zod_1.z.number().optional(),
  discount_rule: zod_1.z.nativeEnum(lingo2_models_1.MeetingDiscountRuleEnum).optional(),
  category_id: zod_1.z.number().optional(),
  media_url: zod_1.z.string().optional(),
  media: zod_1.z.array((0, hash_1.HashSchema)(image_file_1.ImageFileSchema)).optional(),
  keywords: zod_1.z.array(zod_1.z.string()).optional(),
  moderation_message: zod_1.z.string().optional(),
  promotion: zod_1.z.boolean().optional(),
  advertisement: zod_1.z.boolean().optional(),
  publish_status: zod_1.z.nativeEnum(lingo2_models_1.PublishStatusEnum).optional(),
  changed_at: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  purl: zod_1.z.string().optional(),
  hidden: zod_1.z.boolean().optional(),
  readonly: zod_1.z.boolean().optional(),
  participants_limit: zod_1.z.number().default(1),
  options: zod_1.z.object({
    requirements: zod_1.z.array(zod_1.z.string()).optional(),
    skills: zod_1.z.array(zod_1.z.string()).optional(),
    weekdays: zod_1.z.array(zod_1.z.nativeEnum(lingo2_models_1.WeekdaysEnum)).optional(),
    meetings_limit: zod_1.z.number().optional(),
    age_from: zod_1.z.number().optional(),
    age_to: zod_1.z.number().optional()
  }).optional(),
  rating: zod_1.z.number().optional(),
  rating_total: zod_1.z.number().optional(),
  rating_debug: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
  latest_applicable_date: zod_1.z.string().datetime().or(zod_1.z.date()).optional(),
  can: user_service_can_1.UserServiceCanSchema.optional(),
  is: user_service_is_1.UserServiceIsSchema.optional(),
  __opts: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
  // Связанные объекты
  cover: (0, hash_1.HashSchema)(image_file_1.ImageFileSchema).optional(),
  author: account_1.AccountSchema.optional(),
  school: http_endpoints_1.schoolSchema.optional(),
  teachers: zod_1.z.array(account_1.AccountSchema).optional(),
  subject: subject_1.SubjectSchema.optional(),
  language: language_1.LanguageSchema.optional(),
  level: subject_level_1.SubjectLevelSchema.optional(),
  category: user_service_category_1.UserServiceCategorySchema.optional(),
  stats: user_service_stats_1.UserServiceStatsSchema.partial().optional(),
  visit_info: user_service_visit_info_1.UserServiceVisitInfoSchema.partial().optional()
});
